"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("react");exports.default=function(r){var t=e.useRef(r);return e.useEffect((function(){t.current=r}),[r]),t.current};
